import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';

const MobileMenuToggle = ({ isOpen = false, onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      className="mobile-menu-toggle"
      aria-label={isOpen ? t('common.closeMenu') : t('common.openMenu')}
      aria-expanded={isOpen}
      aria-controls="sidebar-navigation"
    >
      <Icon
        name={isOpen ? 'X' : 'Menu'}
        size={24}
        color="var(--color-foreground)"
      />
    </button>
  );
};

export default MobileMenuToggle;
